import { crypt } from './cryptUtils';
import {
  DEFAULT_CRYPT_SALT,
  INFANT_MAX_AGE,
  RESERVATION_TYPES,
} from './xdmConstants';

export const stripEmptyTravellerFields = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v !== null && v !== undefined && v !== ''),
  );

export const optimizedTravellerInfo = (travellerList) =>
  travellerList.map(stripEmptyTravellerFields);

export const splitName = (fullName) => {
  const trimmed = (fullName || '').trim();
  const spaceIndex = trimmed.indexOf(' ');
  if (spaceIndex === -1) return { fname: trimmed, lname: '' };
  return {
    fname: trimmed.substring(0, spaceIndex),
    lname: trimmed.substring(spaceIndex + 1),
  };
};

export const getGenderValue = (traveller) =>
  traveller?.gender?.obj?.value || traveller?.gender?.id || '';

export const getReservationType = (traveller) => {
  const age = traveller?.age || 0;
  return age <= INFANT_MAX_AGE
    ? RESERVATION_TYPES.HALF_TICKET_NO_BERTH
    : RESERVATION_TYPES.FULL_TICKET_FULL_BERTH;
};

export const getBerthPrefValue = (traveller) =>
  traveller?.berthPref?.obj?.key ?? traveller?.berthPref?.id ?? null;

const PII_FIELDS = ['fname', 'lname', 'moblie_com_id', 'email_com_id', 'email_id', 'mob_id'];

export const buildDualTravellerInfo = (travellerList, mapFn, salt) => {
  try {
    const effectiveSalt = salt || DEFAULT_CRYPT_SALT;
    const plainList = (travellerList || []).map((traveller, index) => mapFn(traveller, index));

    const encryptedList = plainList.map((plain) => {
      try {
        const encrypted = { ...plain };
        PII_FIELDS.forEach((field) => {
          if (encrypted[field]) {
            encrypted[field] = crypt(effectiveSalt, encrypted[field]);
          }
        });
        return encrypted;
      } catch {
        return plain;
      }
    });

    return {
      plain: optimizedTravellerInfo(plainList),
      encrypted: optimizedTravellerInfo(encryptedList),
    };
  } catch (error) {
    console.error('[buildDualTravellerInfo] Error:', error?.message);
    return { plain: [], encrypted: [] };
  }
};
